<div *ngIf="consumers.length > 0">
  <h3>Verbraucher</h3>
  <section *ngFor="let consumer of consumers; first as isFirst; last as isLast">
    <h4>
      <span *ngIf="consumer.count">{{ consumer.count.toString() }} x</span>
      {{ consumer.manufacturer }}
      <span *ngIf="consumer.manufacturer && consumer.deviceTypeName">-</span>
      {{ consumer.deviceTypeName }}
    </h4>

    <!-- Gemeinsame Angabe jeder Verbrauchseinrichtung (Formular: „elektr. Leistung (kW)"). -->
    <div>
      <app-value-with-label
        *ngIf="consumer.power != null"
        [label]="'elektr. Leistung (kW):'"
        [value]="consumer.power | number : undefined : 'de-DE'"></app-value-with-label>
    </div>

    <!-- Felder der Ladeeinrichtung (grid-registration-charger-fields). -->
    <ng-container *ngIf="showChargerFields">
      <div>
        <app-value-with-label
          *ngIf="consumer.location"
          [label]="'Art des Standorts:'"
          [value]="consumer.location | powerLocationTypePipe"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="chargerTypeDisplayName(consumer)"
          [label]="'Ladesäulen-Typ:'"
          [value]="chargerTypeDisplayName(consumer)"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.sitePlanAvailable"
          [label]="'Lageplan vorhanden:'"
          [value]="consumer.sitePlanAvailable ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.chargeDeviceAvailable"
          [label]="'Ladeeinrichtung im Übersichtsschaltplan zur Kundeanlage dargestellt:'"
          [value]="consumer.chargeDeviceAvailable ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.chargingPointsNumber"
          [label]="'Anzahl der Ladepunkte insgesamt:'"
          [value]="consumer.chargingPointsNumber.toString()"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.manufacturerDeclaration"
          [label]="'Herstellererklärung vorhanden? (Einhaltung der anerkannten Regeln der Technik):'"
          [value]="consumer.manufacturerDeclaration ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.isP14aStvoException"
          [label]="'Betrieb durch Institutionen gemäß § 35 Abs. 1 und 5a StVO:'"
          [value]="consumer.isP14aStvoException ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>

      <h4 style="padding-top: 1em">Ausführung der Ladeeinrichtung</h4>

      <div>
        <app-value-with-label
          *ngIf="consumer.extractionPowerMax"
          [label]="'Max. Netzentnahmeleistung (kVA):'"
          [value]="consumer.extractionPowerMax.toString()"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.feedPowerMax"
          [label]="'Max. Netzeinspeiseleistung (kVA):'"
          [value]="consumer.feedPowerMax.toString()"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.chargingRangeFrom"
          [label]="'Regelbereich der Ladeleistung von (kVA):'"
          [value]="consumer.chargingRangeFrom.toString()"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.chargingRateTo"
          [label]="'Regelbereich der Ladeleistung bis (kVA):'"
          [value]="consumer.chargingRateTo.toString()"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.acCurrent"
          [label]="'Bei Wechselstrom:'"
          [value]="consumer.acCurrent.toString()"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.interruptibleChargingSystem"
          [label]="'Ladeeinrichtung als unterbrechbare Verbrauchseinrichtung möglich:'"
          [value]="consumer.interruptibleChargingSystem ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>

      <div>
        <app-value-with-label
          *ngIf="consumer.chargingStationInterface"
          [label]="'Schnittstelle Ladesäule-Netzbetreiber vorhanden:'"
          [value]="consumer.chargingStationInterface ? 'Ja' : 'Nein'"></app-value-with-label>
      </div>
    </ng-container>

    <!-- Felder der E-Heizung / Wärmepumpe (grid-registration-heat-pump-fields). -->
    <ng-container *ngIf="showHeatPumpFields">
      <div>
        <app-value-with-label
          *ngIf="consumer.heatPumpType != null"
          [label]="'Art:'"
          [value]="consumer.heatPumpType | powerPumpTypePipe"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.roomHeatingSupplyPowerUsage != null"
          [label]="'Leistung Raumheizung (kW):'"
          [value]="
            consumer.roomHeatingSupplyPowerUsage | number : undefined : 'de-DE'
          "></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.hotWaterSupplyPowerUsage != null"
          [label]="'Leistung Warmwasser (kW):'"
          [value]="consumer.hotWaterSupplyPowerUsage | number : undefined : 'de-DE'"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.maxStartingCurrent != null"
          [label]="'Max. Anlaufstrom (A):'"
          [value]="consumer.maxStartingCurrent | number : undefined : 'de-DE'"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.operationalMode != null"
          [label]="'Betriebsweise der Elektro-Wärmepumpe/-Raumkühlanlage:'"
          [value]="consumer.operationalMode | powerOperationalModeTypePipe"></app-value-with-label>
      </div>
    </ng-container>

    <!-- Zähler (app-gr-meter-number-formpart). -->
    <ng-container *ngIf="hasMeterData(consumer)">
      <h4 style="padding-top: 1em">Zähler</h4>
      <div>
        <app-value-with-label
          *ngIf="consumer.meterNumber"
          [label]="'Zählernummer:'"
          [value]="consumer.meterNumber"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.maLo"
          [label]="'MaLo-Nummer:'"
          [value]="consumer.maLo"></app-value-with-label>
      </div>
    </ng-container>

    <!-- Steuerbarkeit nach § 14a EnWG (grid-registration-p14-formpart). -->
    <ng-container *ngIf="hasP14aData(consumer)">
      <h4 style="padding-top: 1em">Steuerbarkeit nach § 14a EnWG</h4>
      <div>
        <app-value-with-label
          *ngIf="consumer.rateLimitingType"
          [label]="'Wirkleistung steuerbar:'"
          [value]="
            consumer.rateLimitingType | appDisplayName : (metaService.rateLimitingTypes$ | async)
          "></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.controllability"
          [label]="'Bereitstellung der Steuerbarkeit:'"
          [value]="
            consumer.controllability === 'NB' ? 'Netzbetreiber' : 'Messstellenbetreiber'
          "></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.meterOperator"
          [label]="'Messstellenbetreiber:'"
          [value]="consumer.meterOperator"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="consumer.enwgP14aModule"
          [label]="'Reduziertes Netzentgelt:'"
          [value]="p14aModuleDisplayNames[consumer.enwgP14aModule]"></app-value-with-label>
      </div>
    </ng-container>
  </section>
</div>
